import React, { useState, useEffect } from "react";

import { Cadastro, repositorio } from "data/interfaces";
import * as api from "services/firebase";

import { ActionButton } from "../constants";
import {
  Contanier,
  IconEmail,
  IconLike,
  IconMap,
  IconVideo,
  IconZap,
  IconSite,
  IconPhone,
  ContainerIcon,
  Action,
  LabelLike,
  ContainerIconLike,
} from "./styles";

interface OwnProps {
  item: Cadastro;
}

type Props = OwnProps;

const Social: React.FC<Props> = ({ item }: Props) => {
  const [curti, setCurti] = useState<boolean>(false);
  const [qtd, setQtd] = useState<number>(0);

  useEffect(() => {
    console.log(item);
    const qtdTmp = item.curtida ? item.curtida : 1;
    setQtd(qtdTmp);
  }, [item, item.curtida, curti]);

  function HandleEventButton(type: string) {
    switch (type) {
      case ActionButton.ACTION_LIKE:
        handleLike();
        break;
      case ActionButton.ACTION_MAP:
        break;
      case ActionButton.ACTION_SHARE:
        break;
      default:
        break;
    }
  }

  function handleLike() {
    setCurti(true);
    const qtdTmp = item.curtida ? item.curtida + 1 : 1;
    api.doLike(item.key, repositorio.CADASTRO, qtdTmp, (rs) => {
      if (rs === true) {
        setQtd(qtdTmp);
        console.log("Show!", `Obrigado por curtir !`);
      } else {
        console.log("Ops, Ocorreu um problema, tente novamente!");
      }
    });
    setCurti(false);
  }

  return (
    <Contanier>
      <ContainerIcon visible={item.site !== null && item.site !== undefined}>
        <Action href={item.site} rel="noreferrer noopener" target="_blank">
          <IconSite />
        </Action>
      </ContainerIcon>
      <ContainerIcon
        visible={item.telefone !== null && item.telefone !== undefined}
      >
        <Action href={`tel:${item.telefone}`}>
          <IconPhone />
        </Action>
      </ContainerIcon>
      <ContainerIcon
        visible={item.endereco !== null && item.endereco !== undefined}
      >
        <Action
          href={`https://www.google.com/maps/search/?api=1&query=${item.endereco}`}
          rel="noreferrer noopener"
          target="_blank"
        >
          <IconMap />
        </Action>
      </ContainerIcon>
      <ContainerIcon visible={item.email !== null && item.email !== undefined}>
        <Action href={`emailto:${item.email}`}>
          <IconEmail />
        </Action>
      </ContainerIcon>
      <ContainerIcon
        visible={item.whatsap !== null && item.whatsap !== undefined}
      >
        <Action
          href={`https://ActionButtonpi.whatsapp.com/send?phone=${item.whatsap}`}
        >
          <IconZap />
        </Action>
      </ContainerIcon>

      <ContainerIcon
        visible={item.urlVideo !== null && item.urlVideo !== undefined}
      >
        <Action href={item.urlVideo} rel="noreferrer noopener" target="_blank">
          <IconVideo />
        </Action>
      </ContainerIcon>
      <ContainerIconLike
        onClick={() => {
          HandleEventButton(ActionButton.ACTION_LIKE);
        }}
      >
        <LabelLike>{qtd}</LabelLike>
        <IconLike curti={curti} />
      </ContainerIconLike>
    </Contanier>
  );
};

export default Social;
